import { useMutation } from "@tanstack/react-query";

import { createServiceResponseSchema, publicApi } from "@/api/axios";
import { otpVerifiedUserSchema } from "@/domains/profile/models/schemas";
import type { VerifyOtpRequest } from "@/domains/profile/models/types";

export const useVerifyOtp = () => {
  return useMutation({
    mutationFn: verifyOtp,
  });
};

const verifyOtp = async ({ code, email }: VerifyOtpRequest) => {
  const response = await publicApi.post("profilings/otp/verify", {
    email,
    code,
  });

  return createServiceResponseSchema(otpVerifiedUserSchema).parse(response.data).data;
};
